<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      x="12"
      y="20"
      text-anchor="middle"
      fill="currentColor"
      font-size="22"
      font-weight="700"
      textLength="22"
      lengthAdjust="spacingAndGlyphs"
    >
      .00
    </text>
  </svg>
</template>

<script>
export default { name: 'DecimalPlaces' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
